module.exports = __webpack_public_path__ + "img/R2_4_research_matsumoto3.3edef33e.png";